import React from 'react'

import { Button, Image } from 'react-bootstrap'
import excelImg from '../../../images/xlsFile.svg'

export default function ExportExcel({ fnExportExcel }) {


  return (
    <Button className="btn-excel" onClick={() => fnExportExcel()}>
      <Image src={excelImg} style={{ width: '15px' }} />
    </Button>
  )
}
